import React from "react";
import Dropdown from "../DropDown";

interface AwardType {
  award_type_id: number;
  award_type: string;
}

interface MetadataType {
  award_types: AwardType[];
  product_types: any[];
  agg_functions: any[];
}

interface AwardTypeDropdownProps {
  metadata: MetadataType | null;
  selectedAwardType: string;
  onAwardTypeChange: (value: string, selectedObj?: AwardType) => void;
  disabled?: boolean;
  className?: string;
  onFocus?: () => void;
}

const AwardTypeDropdown: React.FC<AwardTypeDropdownProps> = ({
  metadata,
  selectedAwardType,
  onAwardTypeChange,
  disabled,
  className = "",
  onFocus,
}) => {

  const awardTypes: AwardType[] = metadata?.award_types || [];

  const options = awardTypes.map(a => ({
    value: a.award_type,
    label: a.award_type,
  }));

  const handleChange = (value: string) => {
    const obj = awardTypes.find(a => a.award_type === value);
    onAwardTypeChange(value, obj);
  };

  return (
    <Dropdown
      options={options}
      selectedValue={selectedAwardType}
      onValueChange={handleChange}
      disabled={!!disabled}
      className={className}
      placeholder="Select Award Type"
      onFocus={onFocus}
    />
  );
};

export default AwardTypeDropdown;
